import { calendarScheduleInterviewConstants } from "../../_constants";

const initialState = {};

// schedule interview reducer
export const schedule_interview_request_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case calendarScheduleInterviewConstants.SCHEDULE_INTERVIEW_REQUEST_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case calendarScheduleInterviewConstants.SCHEDULE_INTERVIEW_REQUEST_ACTION_SUCCESS:
      return {
        type: "alert-success",
        scheduledInterviewData: action.payload,
      };
    case calendarScheduleInterviewConstants.SCHEDULE_INTERVIEW_REQUEST_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// candidate reducer
export const schedule_interview_request_detail_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case calendarScheduleInterviewConstants.GET_SCHEDULE_INTERVIEW_REQUEST_DETAIL_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case calendarScheduleInterviewConstants.GET_SCHEDULE_INTERVIEW_REQUEST_DETAIL_ACTION_SUCCESS:
      case calendarScheduleInterviewConstants.SCHEDULE_INTERVIEW_REQUEST_ACTION_SUCCESS:
      return {
        type: "alert-success",
        scheduleInterviewDetailData: action.payload,
      };
    case calendarScheduleInterviewConstants.GET_SCHEDULE_INTERVIEW_REQUEST_DETAIL_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};


// schedule interview reducer
export const unregistered_user_schedule_interview_request_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case calendarScheduleInterviewConstants.UNREGISTERED_USER_SCHEDULE_INTERVIEW_REQUEST_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case calendarScheduleInterviewConstants.UNREGISTERED_USER_SCHEDULE_INTERVIEW_REQUEST_ACTION_SUCCESS:
      return {
        type: "alert-success",
        scheduledInterviewData: action.payload,
      };
    case calendarScheduleInterviewConstants.UNREGISTERED_USER_SCHEDULE_INTERVIEW_REQUEST_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// candidate reducer
export const unregistered_user_schedule_interview_request_detail_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case calendarScheduleInterviewConstants.UNREGISTERED_USER_GET_SCHEDULE_INTERVIEW_REQUEST_DETAIL_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case calendarScheduleInterviewConstants.UNREGISTERED_USER_GET_SCHEDULE_INTERVIEW_REQUEST_DETAIL_ACTION_SUCCESS:
      case calendarScheduleInterviewConstants.UNREGISTERED_USER_SCHEDULE_INTERVIEW_REQUEST_ACTION_SUCCESS:
      return {
        type: "alert-success",
        unregisteredUserScheduleInterviewDetailData: action.payload,
      };
    case calendarScheduleInterviewConstants.UNREGISTERED_USER_GET_SCHEDULE_INTERVIEW_REQUEST_DETAIL_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// candidate reducer
export const get_scheduled_interview_detail_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case calendarScheduleInterviewConstants.GET_SCHEDULED_INTERVIEW_DETAIL_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
      case calendarScheduleInterviewConstants.GET_SCHEDULED_INTERVIEW_DETAIL_ACTION_SUCCESS:
      return {
        type: "alert-success",
        scheduledInterviewDetailData: action.payload,
      };
    case calendarScheduleInterviewConstants.GET_SCHEDULED_INTERVIEW_DETAIL_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};
